import { createAlert } from '@src/actions/_utils';
import { AlertTypes } from '@src/constants/MogamboConstants';
import BotStore from '@src/store';

import { BASE_URL } from '../const';
import { MogamboRequest, captureException } from './index';
import { mogamboRequestV2, getEncodedStr } from './utils';


export const fetchTemplates = async (filters = {}) => {
  const paramStr = getEncodedStr(filters);
  const url = `${BASE_URL}/templates/?${paramStr}`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const updateTemplate = async (data, callback) => {
  const url = `${BASE_URL}/templates/`;
  const request = MogamboRequest(url, 'POST', data);

  await fetch(request)
    .then(async (response) => {
      if (response.status === 200) {
        const res = await response.json();
        const selectedSS = JSON.parse(localStorage.getItem('ww_iva'));
        selectedSS.name = data.name;
        localStorage.setItem('ww_iva', JSON.stringify(selectedSS))
        BotStore.getTopbarEvents().refreshSmartSkillsList();
        callback(res);
      } else if (response.status === 403) {
        const defaultErr =
          'You do not have permission to do this.';
        createAlert(
          defaultErr,
          5000,
          AlertTypes.NEGATIVE
        );
      } else {
        const defaultErr = 'Something went wrong.';
        callback({ success: false, error: defaultErr });
        captureException(defaultErr);
      }
    })
    .catch((error) => {
      captureException(error);
    });
};
